/** ---- Dispatch Types ---- */
import { SubContactItemType } from "common/models/SubContactItem";

export const SUB_CONTACT_START = "SUB_CONTACT_START";
export const SUB_CONTACT_CURRENT = "SUB_CONTACT_CURRENT";
export const SUB_CONTACT_CREATED = "SUB_CONTACT_CREATED";
export const SUB_CONTACT_CREATED_ERROR = "SUB_CONTACT_CREATED_ERROR";

/** ---- Dispatch Interfaces ---- */
interface SubContactCreated {
  type: typeof SUB_CONTACT_CREATED;
  payload: SubContactItemType;
}
interface SubContactCreatedError {
  type: typeof SUB_CONTACT_CREATED_ERROR;
}
interface SubContactStart {
  type: typeof SUB_CONTACT_START;
}
interface SubContactCurrent {
  type: typeof SUB_CONTACT_CURRENT;
  payload: SubContactItemType;
}

export type SubContactAction =
  | SubContactCreated
  | SubContactCreatedError
  | SubContactCurrent
  | SubContactStart;
